export enum FormViewsEnum {
  views,
  finished
}
